<template>
  <div class="login">
    <div class="top-title">
      服务商后台
    </div>
    <div class="content">
      <div
        class="form"
        v-if="loginType==='account'"
      >
        <form>
          <div class="form-item">
            <div
              class="form-input"
              @click="domfocus($event,'employeeName')"
            >
              <input 
                ref="employeeName"
                type="number" 
                autocomplete="off"
                placeholder="请输入登录账号"
                v-model.trim="accountFormData.employeeName"
              >
            </div>
          </div>
          <div class="form-item">
            <div
              class="form-input"
              @click="domfocus($event,'password')"
            >
              <input 
                ref="password"
                type="password"
                autocomplete="new-password"
                placeholder="请输入登录密码"
                v-model.trim="accountFormData.password"
              >
            </div>
          </div>
        </form>
      </div>
      <div
        class="form"
        v-if="loginType==='phone'"
      >
        <form>
          <div class="form-item">
            <div
              class="form-input"
              @click="domfocus($event,'telephone')"
            >
              <input 
                ref="telephone"
                type="number" 
                placeholder="请输入注册手机号"
                maxlength="11"
                autocomplete="off"
                inputmode="numeric"
                v-model.trim="phoneFormData.telephone"
              >
            </div>
          </div>
          <div class="form-item">
            <div
              class="form-input"
              @click="domfocus($event,'captcha')"
            >
              <input 
                ref="captcha"
                type="number"
                autocomplete="off"
                placeholder="请输入验证码"
                inputmode="numeric"
                v-model.trim="phoneFormData.captcha"
              >
            </div>
            <van-button
              class="send-code"
              block
              type="info"
              native-type="button"
              :disabled=" timer > 0"
              @click="sendSmsVerifyCode"
            >{{ +timer > 0 ? `${timer}s` : '获取验证码' }}</van-button>
          </div>
        </form>
      </div>
      
      <van-button
        block
        type="info"
        native-type="button"
        @click="onSubmit"
      >登录</van-button>
      <div class="bottom-operate">
        <div 
          class="btn"
          @click="goRegister"
        >注册新用户</div>
        <div
          class="btn" 
          v-show="loginType==='phone'"
          @click="changeLoginType('account')"
        >账号密码登录</div>
        <div
          class="btn" 
          v-show="loginType==='account'"
          @click="changeLoginType('phone')"
        >短信验证码登录</div>
      </div>
    </div>
  </div>
</template>

<script>
import { BAIBU_CONST_CONFIG } from 'baibu-const-config';
import Cookies from 'js-cookie';
import { 
  accountLogin, 
  getSmsVerifyCode,
} from '@/api/baibu';
import { passwordCrypto } from '@/utils/crypto';

export default {
  name: 'Login',
  data() {
    return {
      // account 账号密码登录 phone 手机验证码登录
      loginType: 'account', 
      // 发送短信间隔
      verifyCodeTime: 60,
      // 倒计时
      timer: 0,
      accountFormData: {
        employeeName: '',
        password: '',
        loginType: 'PASSWORD',
      },
      phoneFormData: {
        telephone: '',
        captcha: '',
        loginType: 'SMS',
      },
      
      sourceTypeName: 'provider',
      // token过期时常
      expires: 1800,
    };
  },
  beforeRouteEnter(to, from, next) {
    document.title = '账号登录';
    next();
  },
  methods: {
    domfocus(e, ref) {
      e.stopPropagation();
      e.preventDefault();
      if (this.$refs[ref]) {
        this.$refs[ref].focus();
      }
    },
    changeLoginType(type) {
      this.loginType = type;
    },
    // 获取短信验证码时间限制
    setTimer(seconds) {
      this.timer = seconds;
      const interval = setInterval(() => {
        if (this.timer > 0) {
          this.timer -= 1;
        } else {
          clearInterval(interval);
        }
      }, 1000);
    },
    // 发送短信验证码
    async sendSmsVerifyCode() {
      if (!this.phoneFormData.telephone) {
        this.$toast('请输入注册手机号');
        return;
      }  
      if (!/^1\d{10}$/g.test(Number(this.phoneFormData.telephone))) {
        this.$toast('手机号格式不正确');
        return;
      }
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: '正在提交',
      });
      try {
        const { successful } = await getSmsVerifyCode(
          { phone: this.phoneFormData.telephone }, 
          { 'req-agent': `${this.sourceTypeName}-h5` },
        );
        this.$toast.clear();
        if (successful) {
          this.$toast('验证码发送成功');
          this.setTimer(this.verifyCodeTime);
        }
      } catch (error) {
        this.$toast.clear();
        console.log(error);
      }
    },
    async onSubmit() {
      let sendData = {};
      let message = '';
      if (this.loginType === 'account') {
        message = this.accountValidate();       
        sendData = {
          ...this.accountFormData,
        };
      }

      if (this.loginType === 'phone') {
        message = this.phoneValidate();
        sendData = {
          ...this.phoneFormData,
        };
      }

      if (message) {
        this.$toast(message);
        return;
      }
      this.encryptionEvent(sendData);
    },
    encryptionEvent(sendData) {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: '正在提交',
      });

      if (sendData.password) {
        sendData.password = passwordCrypto(sendData.password, BAIBU_CONST_CONFIG.LOGIN_CRYPTO_KEY);
        this.accountLoginEvent(sendData);
      } else {
        this.accountLoginEvent(sendData);
      }
    },
    accountLoginEvent(sendData) {
      accountLogin(sendData, {
        'req-agent': `${this.sourceTypeName}-h5`,
      }).then((res) => {
        if (res.successful) {
          const expires = new Date(new Date() * 1 + this.expires * 1000);
          Cookies.set(`${this.sourceTypeName}_userId`, res.data.userId, { expires });
          this.$toast.clear();
          this.$router.replace({
            path: '/baibu/provider/login/success',
          });  
        }
      }).catch((error) => {
        this.$toast.clear();
        if (error.code === '555') {
          setTimeout(() => {
            // 登陆弱密码
            this.$router.push({
              path: '/baibu/provider/login/password',
              query: {
                mobilePhone: sendData.employeeName,
              },
            });
          }, 1000); 
        }
        console.log(error);
      });
    },
    // 账号登录验证
    accountValidate() {
      let message = '';
      if (!this.accountFormData.employeeName) {
        message = '请输入登录账号';
        return message;
      } 
      if (!this.accountFormData.password) {
        message = '请输入登录密码';
        return message;
      }
      return message;
    },
    // 手机号登录验证
    phoneValidate() {
      let message = '';
      if (!this.phoneFormData.telephone) {
        message = '请输入注册手机号';
        return message;
      } 
      if (!this.phoneFormData.captcha) {
        message = '请输入短信验证码';
        return message;
      }
      return message;
    },
    // 注册
    goRegister() {
      window.localStorage.removeItem(`${this.sourceTypeName}AccountInfo_signContext`);
      this.$router.push({
        path: `/baibu/registration-agreement/${this.sourceTypeName}`,
      });
    },
  },
  created() {    
    this.$toast.setDefaultOptions({ duration: 1000 });
    if (this.$route.query.employeeName && this.$route.query.password) {
      this.encryptionEvent({
        employeeName: this.$route.query.employeeName,
        password: this.$route.query.password,
        loginType: 'PASSWORD',
      });
    } else if (Cookies.get(`${this.sourceTypeName}_userId`)) {
      this.$router.replace({
        path: '/baibu/provider/login/success',
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.login {
  .top-title {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.32rem;
    font-weight: bold;
    text-align: center;
    border-bottom: 0.01rem solid rgb(228, 226, 226);
    background: #fff;
    z-index: 2;
  }
  .content {
    padding: 1.6rem 0.5rem 0rem 0.5rem;
    .form {
      margin-bottom: 0.5rem;
     &-item {
       display: flex;
       align-items: center;
       flex: 1;
       margin-bottom: 0.3rem;
       height: 0.88rem;
       .send-code {
         width: 3rem;
         margin-left: 0.2rem;
       }
     } 
     &-input {
       display: flex;
       align-items: center;
       width: 100%;
       height: 100%;
       border: 0.01rem solid #e4e7ed;
       border-radius: 0.04rem;
       input{
         padding-left: 0.5rem;
         width: 100%;
         line-height: 0.44rem;;
         font-size: 0.3rem;
         border: 0;
         outline: none;
       }
     }
    }
    .bottom-operate {
      margin-top: 0.5rem;
      display: flex;
      justify-content: space-between;
      padding: 0 0.4rem;
      .btn {
        line-height: 0.6rem;
        color: #1989fa;
        font-size: 0.28rem;
      }
    }
  }
}
</style>
